const Footer = () => {
    return (
      <footer>
        <div className="container">
          <p>&copy; {new Date().getFullYear()} CP Analyzer - Your Competitive Programming Companion</p>
        </div>
      </footer>
    )
  }
  
  export default Footer
  

  